import { Box } from '@factorialco/deprecated-design-system'
import { Widget } from '@factorialco/f0-react/dist/experimental'
import { isEmpty } from 'lodash'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency, { isCurrency } from 'modules/core/lib/money'

import { CustomTwoColumnsList } from 'modules/expenses/components/expenses/Detail/_Form/Common/ConfirmationScreen/CustomTwoColumnList'
import { Expensable } from 'modules/expenses/types/Expensable'

import CustomWidgetHeaderButton from './CustomWidgetHeaderButton'

const buildPerDiemRatesList = (expensable: Expensable, locale: string) => {
  const { perDiem, amount, currency } = expensable
  const perDiemRates = perDiem?.perDiemRates

  const amountToReimburse = parseInt(amount ?? '0')

  const totalToReimburse = isCurrency(currency)
    ? MoneyWithCurrency({
        amount: amountToReimburse,
        currency: currency,
        locale: locale,
      })
    : '0'

  const rates = perDiemRates
    ?.map((rate) => {
      const { rateConfiguration, totalDays } = rate
      const rateConfigurationName = rateConfiguration?.name ?? ''
      const rateConfigurationCurrency = rateConfiguration?.currency ?? ''
      const rateConfigurationRateAmount = rateConfiguration?.amountCents ?? 0

      const totalAmount = rateConfigurationRateAmount
        ? MoneyWithCurrency({
            amount: rateConfigurationRateAmount,
            currency: rateConfigurationCurrency,
            locale: locale,
          })
        : '0'
      const rateDays = totalDays ?? ''
      const rateInfo = i18n.tp(
        'expenses_v2.confirmation_screen.expense.per_diem_rates_block.rate_info',
        {
          count: rateDays,
          rate_configuration_name: rateConfigurationName,
          rate_days: rateDays,
          total_amount: totalAmount,
        }
      )
      return rateInfo
    })
    .join('\n')

  const items = [
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.per_diem_rates_block.rates'),
      info: rates,
    },
    {
      title: i18n.t(
        'expenses_v2.confirmation_screen.expense.per_diem_rates_block.total_to_reimburse'
      ),
      info: totalToReimburse,
    },
  ]

  return items.filter(({ info }) => !isEmpty(info))
}
interface PerDiemRatesWidgetsProps {
  expensable: Expensable
  editable: boolean
  onEdit: () => void
}

const PerDiemRatesWidget = ({ expensable, editable, onEdit }: PerDiemRatesWidgetsProps) => {
  const { access } = useCurrentSession()
  const { locale } = access

  const list = buildPerDiemRatesList(expensable, locale)

  return (
    <Box gap="s16" position="relative">
      <Widget
        header={{
          title: i18n.t('expenses_v2.confirmation_screen.expense.per_diem_rates_block.title'),
        }}
      >
        <CustomTwoColumnsList list={list} />
      </Widget>
      {editable && (
        <CustomWidgetHeaderButton
          label={i18n.t('expenses_v2.confirmation_screen.confirmation_screen_block_edit_action')}
          onClick={onEdit}
        />
      )}
    </Box>
  )
}
export default PerDiemRatesWidget
